import { cacheService, localStore, repositoryActions, getLanguages, service, loadModel, hasModel, sessionStore } from '../../services';
import { convertToLineItem, validateResponse, convertToStockItem, StockModule, apiException } from '../../util';
import { priceDispatcher, productsDispatcher, stockDispatcher, productState } from '..';
import { AppStore } from '..';

const selectorBasedActions = group => selector => repositoryActions( group + '/' + selector.name );
const defaultPageSize = 10;
let currentSelections = {};

function setFromLocalStorage( data, selectorName ) {
  let storedItems = localStore.get( 'pinnedItems' ) || [];
  data.forEach( selector => {
    storedItems?.forEach( pinnedItem => {
      let selectorValue = selector.values.find( x => `${selectorName}#${selector.identifier}#${x.name}` === pinnedItem );
      if ( selectorValue ) {
        selectorValue.isSelected = true;
      }
    } );
  } );
}

const containsStock = () =>{
  const siteSettings = sessionStore.get( 'siteSettings' );
  return siteSettings.stockModule;
}

const setFromCurrentSelections = ( data, selectorName ) => {
  const cleanedName = selectorName.endsWith( ' Fixed Parts' ) ? selectorName.replace( /\ Fixed Parts$/, '' ) : selectorName;
  if( !currentSelections[cleanedName] ) {
    return;
  }

  const selections = currentSelections[cleanedName];
  data.forEach( filter => {
    if( selections[filter.identifier] ) {
      filter.values
        .filter( value => selections[filter.identifier][value.name] !== undefined )
        .forEach( value => value.isSelected = selections[filter.identifier][value.name] );
    } 
  } );
};

function setFromPreFilters( data, selector ) {
  if ( !selector.preFilters || !selector.preFilters.length ) {
    return;
  }
  selector.preFilters.forEach( prefilter => {
    let sel = data.firstOrDefault( filter => filter.identifier.indexOf( '.' + prefilter.identifier ) >= 0 );
    if ( !sel ) {
      return;
    }
    sel.values
      .where( val => prefilter.values.any( preval => preval.value === val.name ) )
      .select()
      .forEach( i => i.isSelected = true );
  } );
}

const addSelectionToCurrentSelections = ( selector, updatedFilter ) => {
  const cleanedName = selector.name.endsWith( ' Fixed Parts' ) ? selector.name.replace( /\ Fixed Parts$/, '' ) : selector.name;
  if( !currentSelections[cleanedName] ) {
    currentSelections[cleanedName] = {};
  }

  if( !currentSelections[cleanedName][updatedFilter.identifier] ) {
    currentSelections[cleanedName][updatedFilter.identifier] = {};
  }

  if( !updatedFilter.properties || !updatedFilter.properties.MultiSelectBehaviour || !updatedFilter.properties.MultiSelectBehaviour !== 'NONE' ) {
    Object.keys( currentSelections[cleanedName][updatedFilter.identifier] )
      .forEach( value => currentSelections[cleanedName][updatedFilter.identifier][value] = false );
  }

  updatedFilter.values.forEach( value => currentSelections[cleanedName][updatedFilter.identifier][value.name] = value.isSelected );
};

export const filterDispatcher = dispatch => ( {
  getFilterSelectors( selector, user, override = false, hasStockFilter = false, updateValues = true,fromSearch=false,fromCart=false  ) {
    // reset will explicitely call the override functionality so we can get them from the service and not from a potential cache
    dispatch( { type: 'dispatch-busy', action: 'filter-active' } );
    if(fromSearch || fromCart){
      return cacheService( 'filterSelector', override )
      .post( { name: selector.name } )
      .then( validateResponse( dispatch )).then( dispatch( { type: 'dispatch-complete', action: 'filter-active' } ))
      .catch( e => {
        return dispatch( { type: 'dispatch-complete', action: 'filter-active' } );
      } )
    }
    else{
    return cacheService( 'filterSelector', override )
      .post( { name: selector.name } )
      .then( validateResponse( dispatch ) )
      .then( forwarded => {
        //accept the condn if function is not called from AccessoryConfiguratorPage
        // if(callFrom !== 'AccessoryConfigurator') {
        // apiException(forwarded, dispatch);
        // }
        if ( hasModel( selector.name, 'selector' ) ) {
          return forwarded;
        }
        return service( 'translations' )
          .get( [ 'selector', selector.name ], { headers: { 'Accept-Language': getLanguages().join( ',' ) } } )
          .then( resp => resp.data )
          .then( ( { values, languages, model, category } ) => loadModel( model, category, languages, values ) )
          .then( () => forwarded );
      } )
      .then( response => {
        // this will only load the first time
        // as the filters are just updated, but not changed 'on the fly'
        setFromLocalStorage( response.data, selector.name );
        if( override ) {
          currentSelections = {};
        }
        hasStockFilter = localStore.get( 'isStockFilterSelected' );
        setFromCurrentSelections( response.data, selector.name );
        // prefilters is set from hierarchy file
        setFromPreFilters( response.data, selector );
        // get the response from the first page, based on this information
        if (updateValues) {
          return this.updateSelectedValue(response.data, selector, user, null, 0, hasStockFilter).then(() => response.data);
        } else {
          dispatch( { type: 'dispatch-complete', action: 'filter-active' } );
          return response.data;
        }
      } ).catch( e => {
        console.log( e );
        return dispatch( { type: 'dispatch-complete', action: 'filter-active' } );
      } )};
  },
  clearFilterSelectors( selector ) {
    dispatch( { type: 'dispatch-busy', action: 'filter-active' } );
    return dispatch( { type: selectorBasedActions( 'selector' )( selector ).CLEAR } );
  },
  updateSelectedValue( filterSelectors, selector, user, updatedFilter = null, page = 0, stockFilter = false, pageSize ) {
    if( updatedFilter ) {
      filterSelectors = filterSelectors.replace( updatedFilter, i => i.identifier );
      addSelectionToCurrentSelections( selector, updatedFilter );
    }
    let filter_properties={}
    filterSelectors.forEach(f=>{
      filter_properties[f.fullyQualifiedName]=f.properties
    })
    filterSelectors.forEach(f=>{f.values.forEach(val=>filter_properties[val.fullyQualifiedName]=val.properties)})
    let filterSelector=[];
    filterSelectors.forEach(f=>filterSelector.push({...f,properties:{"Show":f.properties.Show}}))
    filterSelector.forEach(f=>f.values.map(v=>v.properties={}));
    dispatch( { type: 'dispatch-busy', action: 'filter-active' } );
    return cacheService( 'materials').post( {
      page,
      pageSize: pageSize&&pageSize>defaultPageSize?pageSize:defaultPageSize,
      request: { ...selector, parent: null, filterGroups: filterSelector, hasStockFilter: stockFilter, stockModule : containsStock(),fetchFromMNS:selector.name=="Emax 2"?true:false },
      user
    } )
      .then( validateResponse( dispatch ) )
        .then(response => {
        filterSelector = response.data.request.filterGroups;
        filterSelector.forEach(f=>{
          let property=filter_properties[f.fullyQualifiedName];
          let updatedShow=f.properties.Show;
          Object.assign(f.properties,property)
          f.properties.Show=updatedShow;
        })
        filterSelector.forEach(f=>f.values.forEach(v=>{
          let property=filter_properties[v.fullyQualifiedName];
          Object.assign(v.properties,property)}
        ))
        response.data.request.filterGroups=filterSelector;
        console.log(response.data.request.filterGroups)
        apiException(response, dispatch);
        dispatch( {
          type: selectorBasedActions( 'products' )( selector ).RETRIEVED,
          data: response.data,
          selector
        } );
        return response;
      } )
      .then( validateResponse( dispatch ) )
      .then( response => {
        dispatch( {
        type: selectorBasedActions( 'selector' )( selector ).SET,
        selector,
        filterSelectors: filterSelector || filterSelectors
        } ) 
        return response;
      })
      .then( response => {
        let codes=[];
        let acc_codes=[];
        response.data.results.forEach(res=>{if(res.superCodeLSO){codes.push(res.superCodeLSO)}})
        response.data.results.forEach(prod=>{if(prod.configurableProduct){prod.bomItems.forEach(b=>acc_codes.push(b.name))}})
        if(codes && codes.length>0){productsDispatcher( dispatch ).getProducts(codes).then(res=>
          priceDispatcher( dispatch ).getPrices( res?.products?.map( product=> convertToLineItem(product, user) ) )
          );}
          if(acc_codes && acc_codes.length>0){
          productsDispatcher( dispatch ).getProducts(acc_codes).then(res=>
            priceDispatcher( dispatch ).getPrices( res?.products?.map( product=> convertToLineItem(product, user) ) )
            );  }
        priceDispatcher( dispatch ).getPrices( response.data.results.map( product=> convertToLineItem(product, user) ) );
        stockDispatcher( dispatch ).getStocks( response.data.results.map( convertToStockItem ), response.data.request.hasStockFilter );
        if(response.data.request.metaData.hasBomItems){
          let productsStore = AppStore.getState().productsStore;
          const bomItems = response.data.request.metaData.bomItems;
          productsDispatcher(dispatch).getProducts(bomItems.filter(b => !productsStore[b.value.name])?.map(b => b.value.name), bomItems, user);
        }  
        return response;
      })
      .catch( () => null )
      .then( () => dispatch( { type: 'dispatch-complete', action: 'filter-active' } ) );
  },
  getFilterSelectorValue( filterSelectors, selector, user, updatedFilter = null, page = 0, stockFilter = false ) {
    if( updatedFilter ) {
      filterSelectors = filterSelectors.replace( updatedFilter, i => i.identifier );
      addSelectionToCurrentSelections( selector, updatedFilter );
    }
    
    let filterSelector;
    dispatch( { type: 'dispatch-busy', action: 'filter-active' } );
    return cacheService( 'materials' ).post( {
      page,
      pageSize: defaultPageSize,
      request: { ...selector, parent: null, filterGroups: filterSelectors, hasStockFilter: stockFilter, stockModule : containsStock() },
      user
    } )
      .then( validateResponse( dispatch ) )
      .then( response => {
        filterSelector = response.data.request.filterGroups;
        dispatch( { type: 'dispatch-complete', action: 'filter-active' } );
        return filterSelector;
      } )
      .catch( e => {
        console.log( e );
        return dispatch( { type: 'dispatch-complete', action: 'filter-active' } );
      } );
  }
} );
